export default "__VITE_ASSET__BMIz3SAi__"